export const CREATE_BILL = 'CREATE_BILL';
export const EDIT_BILL = 'EDIT_BILL';
export const SHOW_BILL = 'SHOW_BILL';
export const PAY_BILL = 'PAY_BILL';
export const BILL_SUCCESS = 'BILL_SUCCESS';
export const BILL_ERROR = 'BILL_ERROR';

